import { render, staticRenderFns } from "./CollapseBlock.vue?vue&type=template&id=67bf046e&scoped=true"
import script from "./CollapseBlock.vue?vue&type=script&lang=js"
export * from "./CollapseBlock.vue?vue&type=script&lang=js"
import style0 from "./CollapseBlock.vue?vue&type=style&index=0&id=67bf046e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bf046e",
  null
  
)

export default component.exports